export function anchorLinksClick() {

    const $links = $(".anchor-link");
    
    $links.click(function(e) {
        e.preventDefault();
        let id = $(this).attr("href");
        let targetElement = $(id);
        let elementTop = targetElement.offset().top;
        let headerHeight = $(".header").innerHeight();
        let top = elementTop - (headerHeight + 10);
        
        $("body, html").animate({scrollTop: top}, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchor-links.js